module.exports = __webpack_public_path__ + "img/mlat.82f65c46.jpg";